import { ComponentDeserializer, SerializableComponent } from '@inter-ikea-core/core';

const componentSerializationKey_oldPlatsa = 'PlatsaTopComponent'; // This component was previously PLATSA specific with this serializationKey
const componentSerializationKey = 'TopComponent';

/**
 * This component should be added to the frame and signals that
 * the user has done an active choise if frame should have top or
 * not so the TopPanelSystem doesn't change that.
 */
export class FrameTopComponentSerializer implements ComponentDeserializer {
  thisClassIsGuaranteedToNotModifyOrQueryCoreState = true;
  canHandle(serializationKey: string) {
    return (
      serializationKey === componentSerializationKey ||
      serializationKey === componentSerializationKey_oldPlatsa
    );
  }

  deserialize(serializationKey: string) {
    switch (serializationKey) {
      case componentSerializationKey:
      case componentSerializationKey_oldPlatsa:
        return new FrameTopComponent();
    }
    return null;
  }
}

export default class FrameTopComponent implements SerializableComponent {
  static id = 2044;
  typeId = FrameTopComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable = true;

  serializationKey(): string {
    return componentSerializationKey;
  }

  toJson(parse: (json: string) => any): any {
    return parse(JSON.stringify(this));
  }

  eq() {
    return true;
  }
}
